export default "__VITE_PUBLIC_ASSET__509600fa__"